var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fsl-confirm"},[_c('button',{staticClass:"button button-primary",on:{"click":_vm.handleBack}},[_vm._v("Return to OTS\n    ")])])}
var staticRenderFns = []
export { render, staticRenderFns }